import {DOCUMENT} from "@angular/common";
import {inject, Injectable} from '@angular/core';

export const DEFAULT_SCRIPT_TYPE = 'application/ld+json';

@Injectable({
  providedIn: 'root'
})
export class JsonLdService {
  private document: Document = inject(DOCUMENT);

  public setSchema(schemaObject: Record<string, any>): void {
    let scriptTag: HTMLScriptElement | null = this.document.querySelector(`script[type="${DEFAULT_SCRIPT_TYPE}"]`);
    if (!!scriptTag) {
      scriptTag.textContent = JSON.stringify(schemaObject, null, 2);
    } else {
      scriptTag = this.document.createElement('script');
      scriptTag.type = DEFAULT_SCRIPT_TYPE;
      scriptTag.textContent = JSON.stringify(schemaObject, null, 2);
      this.document.head.appendChild(scriptTag);
    }
  }

  public removeSchema(): void {
    const scriptTag = this.document.querySelector(`script[type="${DEFAULT_SCRIPT_TYPE}"]`);
    if (scriptTag) {
      this.document.head.removeChild(scriptTag);
    }
  }
}
